import { defineMessages } from 'react-intl'

const scope = `procurify.components.Importer`

export default defineMessages({
  uploadingStepTitle: {
    id: `${scope}.uploadingStepTitle`,
    defaultMessage: 'Uploading CSV...',
  },
  uploadingStepCriteriaTitle: {
    id: `${scope}.uploadingStepCriteriaTitle`,
    defaultMessage:
      'Double check if you have the following criteria for your CSV before importing:',
  },
  uploadingStepCancelButton: {
    id: `${scope}.uploadingStepCancelButton`,
    defaultMessage: 'Cancel',
  },
  uploadingStepImportButton: {
    id: `${scope}.uploadingStepImportButton`,
    defaultMessage: 'Import',
  },
  uploadingStepTemplateTitle: {
    id: `${scope}.uploadingStepTemplateTitle`,
    defaultMessage: 'Need a Template?',
  },
  uploadingStepTemplateDescription: {
    id: `${scope}.uploadingStepTemplateDescription`,
    defaultMessage:
      'Download the Procurify importer template and add your <strong>{title}</strong> information accordingly. This is to make your import process easier. For more information please visit the support page.',
  },
  uploadingStepDownloadTemplateButton: {
    id: `${scope}.uploadingStepDownloadTemplateButton`,
    defaultMessage: 'Download Template',
  },
  processingStepTitle: {
    id: `${scope}.processingStepTitle`,
    defaultMessage: 'Processing CSV...',
  },
  processingStepDescription: {
    id: `${scope}.processingStepDescription`,
    defaultMessage: `<strong>Please Wait...</strong> We're uploading your file right now.`,
  },
  previewStepTitle: {
    id: `${scope}.previewStepTitle`,
    defaultMessage: 'Map the Columns & Review',
  },
  previewStepDescription: {
    id: `${scope}.previewStepDescription`,
    defaultMessage:
      'Here is a preview of your imported data. You can re-map the columns by pressing the "X" button. You can also select the proper label using the subsequent dropdown box.',
  },
  previewStepOverlayText: {
    id: `${scope}.previewStepOverlayText`,
    defaultMessage: 'PREVIEW OF THE DATA TO BE IMPORTED',
  },
  previewStepBackButton: {
    id: `${scope}.previewStepBackButton`,
    defaultMessage: 'Back',
  },
  previewStepImportButton: {
    id: `${scope}.previewStepImportButton`,
    defaultMessage: 'Import',
  },
  successStepTitle: {
    id: `${scope}.successStepTitle`,
    defaultMessage: 'Importing Complete!',
  },
  successStepAltLabel: {
    id: `${scope}.successStepAltLabel`,
    defaultMessage: 'Import successful image',
  },
  successStepDescription: {
    id: `${scope}.successStepDescription`,
    defaultMessage:
      '{CREATE} <strong>{itemName}</strong> successfully imported',
  },
  successCreatedDescription: {
    id: `${scope}.successCreatedDescription`,
    defaultMessage: 'successfully imported',
  },
  successDeactivatedDescription: {
    id: `${scope}.successDeactivatedDescription`,
    defaultMessage: 'successfully deactivated',
  },
  successIgnoredDescription: {
    id: `${scope}.successIgnoredDescription`,
    defaultMessage: 'successfully ignored',
  },
  successUpdatedDescription: {
    id: `${scope}.successUpdatedDescription`,
    defaultMessage: 'successfully updated',
  },
  successStepDoneButton: {
    id: `${scope}.successStepDoneButton`,
    defaultMessage: 'Done',
  },
  errorImageLabel: {
    id: `${scope}.errorImageLabel`,
    defaultMessage: 'Import error image',
  },
  legacyErrorStepTitle: {
    id: `${scope}.legacyErrorStepTitle`,
    defaultMessage: `Oops! We had trouble importing some of the rows`,
  },
  errorStepTitle: {
    id: `${scope}.errorStepTitle`,
    defaultMessage: `We couldn't import {failedRowCount} rows from your file.`,
  },
  errorStepDescriptionTitle: {
    id: `${scope}.errorStepDescriptionTitle`,
    defaultMessage: `We've successfully imported the error-free rows from your CSV. Here's a new CSV that only contains the rows with errors. In this new CSV, we've added a column at the end containing the error details for each row.`,
  },
  errorStepDescriptionSubtitle: {
    id: `${scope}.errorStepDescriptionSubtitle`,
    defaultMessage: `Next Steps for you:`,
  },
  errorStepDescriptionContentItemOne: {
    id: `${scope}.errorStepDescriptionContentItemOne`,
    defaultMessage: `1. Download this CSV.`,
  },
  errorStepDescriptionContentItemTwo: {
    id: `${scope}.errorStepDescriptionContentItemTwo`,
    defaultMessage: `2. Note the error details in the last column of each row.`,
  },
  errorStepDescriptionContentItemThree: {
    id: `${scope}.errorStepDescriptionContentItemThree`,
    defaultMessage: `3. Correct the errors in each row and save the file.`,
  },
  errorStepDescriptionContentItemFour: {
    id: `${scope}.errorStepDescriptionContentItemFour`,
    defaultMessage: `4. Re-upload the corrected CSV file below.`,
  },
  errorReminderToReupload: {
    id: `${scope}.errorReminderToReupload`,
    defaultMessage: `Re-upload your corrected files here`,
  },
  errorStepCancelButton: {
    id: `${scope}.errorStepCancelButton`,
    defaultMessage: 'Cancel',
  },
  errorStepImportButton: {
    id: `${scope}.errorStepImportButton`,
    defaultMessage: 'Import',
  },
  ignoreFirstRow: {
    id: `${scope}.ignoreFirstRow`,
    defaultMessage: 'Ignore First Row',
  },
  fileSizeExceeded: {
    id: `${scope}.fileSizeExceeded`,
    defaultMessage: `This file is larger than {maxFileSize} MB. Please upload a file within the size limit.`,
  },
  wrongFileType: {
    id: `${scope}.wrongFileType`,
    defaultMessage: `This file is not a {fileTypeName}. Please try again.`,
  },
  incompleteFileErrorMessage: {
    id: `${scope}.incompleteFileErrorMessage`,
    defaultMessage: `The file you uploaded only has {numCols} {numCols, plural,
        one {column}
        other {columns}
      }, but the importer requires at least {numReqFields} columns. Please check your CSV for the required fields listed below.`,
  },
  emptyErrorStepTitle: {
    id: `${scope}.emptyErrorStepTitle`,
    defaultMessage: `Oops! It looks like you uploaded an empty CSV.`,
  },
  genericErrorStepDescription: {
    id: `${scope}.genericErrorStepDescription`,
    defaultMessage: `Please try your upload again.`,
  },
  genericErrorStepTitle: {
    id: `${scope}.genericErrorStepTitle`,
    defaultMessage: `Oops! It looks like there's an error.`,
  },
  incompleteErrorStepDescription: {
    id: `${scope}.incompleteErrorStepDescription`,
    defaultMessage: `The file you uploaded did not meet the minimum requirements. The problem could be due to a lack of columns within your file. You need a minimum of {minColumns} columns to upload.`,
  },
  missingColumnsTooltip: {
    id: `${scope}.missingColumnsTooltip`,
    defaultMessage: `Column {numFields, plural,
      one {field}
      other {fields}
    } <strong>{fields}</strong> {numFields, plural,
      one {is}
      other {are}
    } missing but required.`,
  },
  errorStepGoBackToUpload: {
    id: `${scope}.errorStepGoBackToUpload`,
    defaultMessage: `Upload File Again`,
  },
  proLicenseExceededTitle: {
    id: `${scope}.proLicenseExceededTitle`,
    defaultMessage: `You don't have enough Pro licenses`,
  },
  proLicenseExceededDescription: {
    id: `${scope}.proLicenseExceededDescription`,
    defaultMessage:
      'This import would assign more Pro roles than your account has licenses for.',
  },
  proLicenseExceededAction: {
    id: `${scope}.proLicenseExceededAction`,
    defaultMessage:
      'Remove Pro roles from some users or {contactSalesLink} to add more licenses.',
  },
  proLicenseExceededContactSales: {
    id: `${scope}.proLicenseExceededContactSales`,
    defaultMessage: 'contact sales',
  },
  proLicenseExceededUploadNewFile: {
    id: `${scope}.proLicenseExceededUploadNewFile`,
    defaultMessage: `Upload new file`,
  },
  legacyErrorChecklistHint: {
    id: `${scope}.legacyErrorChecklistHint`,
    defaultMessage: `Hint: Check off each item you've fixed by clicking on it`,
  },
  legacyErrorFixTitle: {
    id: `${scope}.legacyErrorFixTitle`,
    defaultMessage: ' How to fix the errors',
  },
  option1: {
    id: `${scope}.option1`,
    defaultMessage: 'Option 1',
  },
  option2: {
    id: `${scope}.option2`,
    defaultMessage: 'Option 2',
  },
  legacyErrorUploadAgain: {
    id: `${scope}.legacyErrorUploadAgain`,
    defaultMessage: `{failedRowCount} {title} have errors listed above. Please correct
              the {title} in your CSV and upload it again.`,
  },
  legacyErrorMapAgain: {
    id: `${scope}.legacyErrorMapAgain`,
    defaultMessage: `There might be issues with the way the columns are mapped in your
        CSV. When you're ready to correct the errors, please click the
        button below to go back to the Mapping Tool.`,
  },
  backToToolButton: {
    id: `${scope}.backToToolButton`,
    defaultMessage: 'Bring me back to the tool',
  },
  downloadErrors: {
    id: `${scope}.downloadErrors`,
    defaultMessage: 'Download Errors',
  },
  improvedErrorStepTitle: {
    id: `${scope}.improvedErrorStepTitle`,
    defaultMessage: `There are {failedRowCount} errors in your CSV file.`,
  },
  errorStepDescriptionOne: {
    id: `${scope}.errorStepDescriptionOne`,
    defaultMessage: `Please review the list of errors below. You can check them off as you go for your convenience.`,
  },
  errorStepDescriptionTwo: {
    id: `${scope}.errorStepDescriptionTwo`,
    defaultMessage: `To learn more about potential import errors and how to fix them please review `,
  },
  errorGuideLink: {
    id: `${scope}.errorGuideLink`,
    defaultMessage: 'this guide.',
  },
  improvedErrorFixTitle: {
    id: `${scope}.improvedErrorFixTitle`,
    defaultMessage: 'How can I fix these errors?',
  },
  errorFixOptionOneTitle: {
    id: `${scope}.errorFixOptionOneTitle`,
    defaultMessage: 'Option 1: Edit your CSV',
  },
  errorFixOptionOneDescription: {
    id: `${scope}.errorFixOptionOneDescription`,
    defaultMessage: `Correct the errors in your CSV file and upload again.`,
  },
  errorFixOptionTwoTitle: {
    id: `${scope}.errorFixOptionTwoTitle`,
    defaultMessage: 'Option 2: Column mapping',
  },
  errorFixOptionTwoDescription: {
    id: `${scope}.errorFixOptionTwoDescription`,
    defaultMessage: `There might be issues with the way columns are mapped in your CSV file.`,
  },
  uploadAgainButton: {
    id: `${scope}.uploadAgainButton`,
    defaultMessage: 'Upload Again',
  },
  remapColumnsButton: {
    id: `${scope}.remapColumnsButton`,
    defaultMessage: 'Remap Columns',
  },
  cancelImportButton: {
    id: `${scope}.cancelImportButton`,
    defaultMessage: 'Cancel Import',
  },
  lineLabel: {
    id: `${scope}.lineLabel`,
    defaultMessage: 'Line',
  },
  fieldLabel: {
    id: `${scope}.fieldLabel`,
    defaultMessage: 'field',
  },
  errorListRowLabel: {
    id: `${scope}.errorListRowLabel`,
    defaultMessage: 'Row',
  },
  errorListColumnLabel: {
    id: `${scope}.errorListColumnLabel`,
    defaultMessage: 'Column',
  },
  errorListValueLabel: {
    id: `${scope}.errorListValueLabel`,
    defaultMessage: 'Value',
  },
  errorListErrorLabel: {
    id: `${scope}.errorListErrorLabel`,
    defaultMessage: 'Error',
  },
  errorListInstancesLabel: {
    id: `${scope}.errorListInstancesLabel`,
    defaultMessage: 'instances',
  },
  errorGroupSelectCheckboxLabel: {
    id: `${scope}.errorGroupSelectCheckboxLabel`,
    defaultMessage: 'Import Error Group Select Checkbox',
  },
  errorSelectCheckboxLabel: {
    id: `${scope}.errorSelectCheckboxLabel`,
    defaultMessage:
      'Import Error Select Checkbox Row {csvLineIndex} - {errorField}',
  },
})
